import { useState, useEffect } from "react";
import { SERVER_HOST } from "../constants/config";
import { getEkycHeaders } from "../utils/ekycHeaders";

const useSignedUrl = (s3Key) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!s3Key) return;

    const validationID = sessionStorage.getItem("ekycValidationID");
    if (!validationID) return;

    fetch(
      `${SERVER_HOST}/assets/ekyc-signed?key=${encodeURIComponent(s3Key)}&validationID=${validationID}`,
      { headers: getEkycHeaders() }
    )
      .then((res) => res.json())
      .then((result) => {
        if (result.status === "success") {
          setUrl(result.data.url);
        }
      })
      .catch(() => {});
  }, [s3Key]);

  return url;
};

export default useSignedUrl;
